// extracted by mini-css-extract-plugin
export default {"sliderContainer":"index_sliderContainer_uDtLF","text_mask":"index_text_mask_IKrfT","test":"index_test_Qb2QG","dot":"index_dot_bmb-E","current":"index_current_K0V1u"};